module.exports = __webpack_public_path__ + "355CC9_1_0.ttf?8f6796c24f0f7d9dff028d21d7640bbf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_1_0.ttf
// module id = 36
// module chunks = 0